<template>
	<div>
		<ihead :checkindex='checkindex'></ihead>
		<div class="banner-box">
			<h1>{{title}}</h1>
		</div>
		<mu-container>
			<mu-breadcrumbs>
				<mu-breadcrumbs-item
					v-for="(item, index) in items"
					:key="index"
					:to="item.to"
					:disabled="item.disabled"
					>{{ item.text }}</mu-breadcrumbs-item>
			</mu-breadcrumbs>
		</mu-container>
		<Details :mainid='this.mainid' :subid='this.subid' :detailList='detailList' :preList='preList' :nextList='nextList' :judgeList='judgeList' :content='content' :preTrue='preTrue' :nextTrue='nextTrue'></Details>
		<ifoot></ifoot>
		<returntop class="return-top"></returntop>
	</div>
</template>
<script>
import ihead from "@/components/ihead.vue"
import ifoot from '@/components/ifoot.vue'
import crumbs from "@/components/crumbs.vue"
import Details from '@/components/details'
import returntop from '@/components/returntop'
export default {
	components: {
			ihead,ifoot,crumbs,Details,returntop
	},
	data(){
		return{
			title: "",
			checkindex:5,
			id: this.$route.query.id,
			cid:this.$route.query.cid,
			mainid: this.$route.query.mainid,
      		subid: this.$route.query.subid,
			items: [
			{
				text: "首页",
				to: "/",
				disabled: false
			},
			{
				text: "",
				disabled: true
			},
			{
				text: "",
				disabled: true
			}
		],
			judgeList: {key:false},
			content: '',
			detailList:[{
				id:1,
				title:'',
				create_time:'',
				picture:{path:''},
				dataContent:''
			}],
			preTrue:{key:false},
			preList:[{
				id:1,
				title:'',
				create_time:''
			}],
			nextTrue:{key:false},
			nextList:[{
				id:1,
				title:'',
				create_time:''
			}]
		}
	},
	created(){
		this.getDetailList()
		this.getNav()
		this.getNextPage()
	},
	watch: {
		$route(to, from) {
			this.id = to.query.id	
			this.getDetailList()
			this.subid = to.query.subid
			this.mainid = to.query.mainid
			this.getNav()
			this.getNextPage()
		}
	},
	methods:{	
		getDetailList(){
			let data = {
				id: this.id
			};
			this.$get('/article/get-article-detail',data).then(res => {			
				if(res.code == 0){							
					res.data.create_time = this.$getData(res.data.create_time)
					this.detailList[0] = res.data 
					this.content = res.data.content
					// this.getCount()
				}else{
					// console.log(res.message)
				}
			})
		},
		getCount () {
			let data = {
				id: this.id
			}
			this.$get('/article/plus-view-count', data).then(res => {
				if(res.code == 0){
				}else{
					// console.log(res.message)
				}
			})
		},
		getNextPage () {
			let data = {
				cid: this.cid,
				id: this.id
			}
			this.$get('/article/get-next-article', data).then(res => {			
				if(res.code == 0){
					let data = res.data				
					if(data.prev_article && data.prev_article.category_id){
						this.preTrue.key = true
						data.prev_article.create_time = this.$getData(data.prev_article.create_time)
						this.preList[0] = data.prev_article
					}else{
						this.preTrue.key = false
					}
					if(data.next_article && data.next_article.category_id){
						this.nextTrue.key = true
						data.next_article.create_time = this.$getData(data.next_article.create_time)
						this.nextList[0] = data.next_article
					}else{
						this.nextTrue.key = false
					}
				}else{
					// console.log(res.message)
				}
			})
		},
		getNav() {
			this.$get("/nav/get-nav-tree").then(res => {
				if (res.code === 0) {
					let data = res.data
					if (data.length > 0) {
						let newData = data.filter((item, index, array) => {
							return item.id === this.mainid
						})
						this.$set(this.items[1], "text", newData[0].text)
						if (newData[0].children) {
							let subData = newData[0].children
							let newSubData = subData.filter((item, index, array) => {
								return item.id === this.subid
							})
							this.$set(this.items[2], "text", newSubData[0].text)
							this.title = newSubData[0].text
						}
					}
				} else {
					// console.log(res.message)
				}
			})
		}
	}
}
</script>
<style>
@media screen and ( max-width: 768px){
	.article-right{
		display: none;
	}
	.article-left{
		width: 100%;
		margin: 0;
	}
	.article-box{
		/* margin: 0 15px; */
	}
	.art-img{
		width: 90%;
		margin: 5%;
	}
	.article-box .article-left img{
		width: 100%;
	}
}
@media screen and ( max-width: 320px) {			
}
</style>
